import { Typography } from '@mui/material';

import { ContentContainer, GradientIndicator, StyledButton } from './styled';

type TabButtonProps = Omit<React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>, 'children'> & {
  isActive?: boolean;
  text?: string;
  isMobile?: boolean;
};

export default function TabButton({ type = 'button', isActive = false, isMobile = false, text, ...remainder }: TabButtonProps) {
  return (
    <StyledButton {...remainder} type={type}>
      <ContentContainer data-is-active={isActive}>
        <Typography variant={isMobile ? 'h8' : 'h6'}>{text}</Typography>
        {isActive && <GradientIndicator />}
      </ContentContainer>
    </StyledButton>
  );
}
